<template>
  <div class="editor">
    <div v-if = "false" class = "debug2">
      <p>{{projectId}}</p>
      <p>{{project.codefiles}}</p>
    </div>

    <!-- main editor components
    <editor-toolbar v-if = "editorConfig.isShowingToolbar" :project = "project" class = "h" ></editor-toolbar>
    -->

    <editor-tabs v-if = "editorConfig.isShowingTabs" :project = "project" class = "t" ></editor-tabs>
    <editor-textarea-ace v-show = "true" :project = "project" :tabs = "tabs" class = "e"></editor-textarea-ace>

    <editor-sketch-bar class = "i"></editor-sketch-bar>

    <!-- settings -->
    <b-modal :active.sync="editorConfig.isShowingSettings" has-modal-card>
      <editor-settings :project = "project" @save="project"></editor-settings>
    </b-modal>

    <b-modal :active.sync="editorConfig.isShowingSubmit" has-modal-card>
      <editor-send-project  :project = "project" ></editor-send-project>
    </b-modal>

    <!-- createProject -->
    <b-modal :active.sync="editorConfig.isShowingCreateProject" has-modal-card :canCancel="false">
      <editor-create-project></editor-create-project>
    </b-modal>

    <!-- notification -->
    <b-notification :active.sync="showAlert">
      Se ha generado una URL para tu proyecto.
      <div> http://programalaplaza.medialab-prado.es/editor/{{projectId}}</div>
      ¿has pensado en registrarte en la plataforma? Si trabajas en un proyecto en serio es la mejor forma de no perder tu trabajo.
      <a class="button"  @click="showLogin = true" >login</a>
    </b-notification>
  </div>
</template>

<script>
/* This module can be loaded in 3 ways
1) as a normal component, where we specify the codeId through props
2) from gallery -> route changes
3) entering directly to the url -> grabs id from url and tells store to fetch the project
*/

import EditorTabs from './EditorTabs'
import EditorTextareaAce from './EditorTextareaAce'
import EditorSettings from './EditorSettings'
import EditorSketchBar from './EditorSketchBar'
import EditorSendProject from './EditorSendProject'
import EditorCreateProject from './EditorCreateProject'
import CustomSnackbar from '../UI/CustomSnackbar'

export default {
  name: 'Editor',
  components: {
    EditorTabs,
    EditorTextareaAce,
    EditorSettings,
    EditorSketchBar,
    EditorCreateProject,
    EditorSendProject,
    CustomSnackbar
  },
  props: {
    projectId: String,
    exampleType: String,
    exampleId: String
  },
  watch: {
    '$route': function (oldRoute, newRoute) {
      this.init()
    }
  },
  data () {
    return {
      tabs: {},
      fileEditing: 'main',
      showSettings: false,
      showAlert: false,
      showRegister: false,
      showLogin: false,
      showCreateProject: false
    }
  },
  computed: {
    project () {
      return this.$store.state.project
    },
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    init: function () {
      // this.$store.commit('clearProject')
      this.$store.dispatch('auth/initialize')

      switch (this.$route.name) {
        case 'Editor':
          if (this._.isEmpty(this.project)) {
            this.$router.push({ name: 'Editor.create' })
          }
          break

        case 'Editor.create':
          // console.log('Editor.create')
          // this.$store.commit('setProject', emptyProject)

          /*
          TODO hay que mirar el workflow de esto
          if (!(localStorage.getItem('projectId') === null)) {
            CustomSnackbar.open({
              message: 'Hay un proyecto anterior guardado en este ordenador puedes cargarlo si lo deseas',
              type: 'is-warning',
              position: 'is-top',
              actionText: 'Cargar',
              duration: 8000,
              indefinite: false,
              onAction: () => {
                this.$router.push({ name: 'Editor.load', params: { projectId: localStorage.getItem('projectId') } })
              }
            })
          }
          */
          this.$store.commit('setEditorConfigProperty', {'isShowingCreateProject': true})
          break

        case 'Editor.created':
          this.$store.dispatch('createProjectWithoutSaving')
          // this.showEndOfCall()
          break

        case 'Editor.load':
          this.$store.dispatch('fetchProject', this.projectId)
            .catch((error) => {
              if (error.response.status === 403 || error.response.status === 401) {
                this.$snackbar.open({
                  message: 'Este proyecto es privado. No tienes permiso para abrirlo',
                  type: 'is-danger',
                  position: 'is-top',
                  actionText: 'Ok',
                  queue: false,
                  duration: 12000
                  // onAction: () => {
                  //   this.$router.push({name: 'login'})
                  // }
                })
              }
            })
          // this.showEndOfCall()
          break

        case 'Editor.example':
          this.$store.dispatch('fetchExample', { type: this.exampleType, id: this.exampleId })
          break

        case 'Editor.clone':
          this.$store.dispatch('cloneProject', this.projectId)
          break

        default:
      }
      // for auth users get userinfo
      if (this.$store.getters['auth/isAuthenticated']) this.$store.dispatch('user/fetchUserInfo')
    },
    reloadFn: function (e) {
      if (e.ctrlKey && e.code === 'KeyR') {
        // console.log('reload')
        // console.log(this.editorConfig.isSketchRunning)
        this.$store.commit('setEditorConfigProperty', {'isSketchRunning': !this.editorConfig.isSketchRunning})
        e.preventDefault()
        e.stopPropagation()
        window.event.cancelBubble = true
      } else if (e.ctrlKey && e.code === 'KeyS') {
        this.$store.dispatch('handleSaveProject')
        e.preventDefault()
        e.stopPropagation()
        window.event.cancelBubble = true
      }
    },
    showToast: function (msg) {
      this.$toast.open({
        message: msg
      })
    },
    createdProjectInDb: function () {
      CustomSnackbar.open({
        message: 'Proyecto guardado. Estás trabajando como usuario anónimo. Sólo podrás abrir este proyecto en otro navegador guardando el link. Registrate para no perder acceso',
        position: 'is-top',
        actionText: 'Acceder',
        duration: 7000,
        indefinite: false,
        onAction: () => {
          this.$emit('showLoginEmit')
        }
      })
    },
    showEndOfCall () {
      this.$toast.open({
        duration: 5000,
        message: 'Ya ha concluido la convocatoria de proyectos de 2019. Puedes seguir usando la plataforma pero no puedes enviar tu proyecto',
        position: 'is-bottom',
        type: 'is-warning'
      })
    }
  },
  created () {
    window.onbeforeunload = (e) => {
      let msg = null

      if (this.editorConfig.changesCounter > 10) {
        msg = '¿Quieres salir del Editor?'
      }
      return msg
    }
    window.addEventListener('keydown', this.reloadFn)
    this.$eventHub.$on('showToast', this.showToast)
    this.$eventHub.$on('createdProjectInDb', this.createdProjectInDb)

    // resear la consola
    this.$store.commit('clearConsole')

    this.init()
  },
  mounted () {
    this.$store.dispatch('fetchExamplesList')
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    this.$store.commit('setEditorConfigProperty', {'isSketchRunning': false})
    window.removeEventListener('keydown', this.reloadFn)
    window.onbeforeunload = null
    document.body.style.overflow = 'auto'
  },
  beforeDestroy () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.editor {
  background: @backgroundColor;
  height: 100%;
  display: grid;
  // 60px 50px auto 46px;
  grid-template:  "t t i" 50px
                  "e e i" auto;
  grid-template-columns: auto auto 380px;
  min-height: 0;
}

@media (max-width: @breakPoint) {
  .editor {
    grid-template:  "t t t" 50px
                    "e e e" auto
                    "i i i" 46px;
  }
}

.h { grid-area: h; }
.t { grid-area: t; }
.e { grid-area: e; }
.i { grid-area: i; }

.debug2 {
  position: absolute;
  z-index: 12;

  p {
    background: white;
    padding: 12px;
    margin: 12px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Editor/Editor.vue